<script setup lang="ts">
import type { Project } from '~/types/project'

defineProps<Project>()
</script>

<template>
  <component
    :is="url ? 'a' : 'div'"
    v-bind="url ? { href: url, target: '_blank' } : {}"
    class="group flex flex-col rounded-xl border border-default bg-elevated overflow-hidden transition-all duration-200"
    :class="url ? 'hover:border-zinc-600 hover:-translate-y-0.5 hover:shadow-lg' : ''"
  >
    <!-- Thumbnail -->
    <div class="aspect-video bg-gradient-to-br from-zinc-800 to-zinc-900 flex items-center justify-center overflow-hidden">
      <NuxtImg
        v-if="thumbnail"
        :src="thumbnail"
        :alt="title"
        width="768"
        height="432"
        sizes="100vw sm:50vw lg:340px"
        quality="80"
        loading="lazy"
        decoding="async"
        class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
      />
      <div
        v-else
        class="flex flex-col items-center gap-1 text-muted opacity-30"
      >
        <UIcon
          name="i-lucide-code-2"
          class="size-8"
        />
        <span class="text-xs">{{ client }}</span>
      </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-1 p-4">
      <div class="flex items-start justify-between gap-2 mb-1">
        <h3 class="font-semibold text-highlighted text-base leading-snug">
          {{ title }}
        </h3>
        <UIcon
          v-if="url"
          name="i-lucide-external-link"
          class="size-3.5 text-muted opacity-0 group-hover:opacity-100 transition-opacity shrink-0 mt-0.5"
        />
      </div>

      <p class="text-sm text-muted mb-3">
        {{ client }} · {{ year }}
      </p>

      <p
        v-if="description"
        class="text-sm text-muted leading-relaxed mb-3 flex-1"
      >
        {{ description }}
      </p>

      <div class="flex flex-wrap gap-1 mt-auto">
        <UBadge
          v-for="tech in techStack"
          :key="tech"
          variant="subtle"
          size="sm"
          class="text-zinc-700 dark:text-zinc-200"
        >
          {{ tech }}
        </UBadge>
      </div>
    </div>
  </component>
</template>
